import { useTranslation } from 'react-i18next';
import KoobSpinner from '@koob/ui/src/components/KoobSpinner';

export default function NotificationPopoverLoading() {
  const { t } = useTranslation('notifications');

  return (
    <div className="h-56 flex justify-center items-center">
      <KoobSpinner />
    </div>
  );
}
